import { observer } from "mobx-react";

import ShowModal from "@component/ShowModal";
import Training from "@model/Training";
import TrainingShowVM from "@vm/Show/Training";
import { lazyInject, TYPES } from "../../../inversify.config";

import TrainingForm from "./Form";

@observer
export default class TrainingShowModal extends ShowModal<Training> {
  modelName = "training";
  prefix = "employee";

  @lazyInject(TYPES.TrainingShow)
  vm: TrainingShowVM;

  onClose = () => {
    this.router.pageLink(this.uriHelper.employees_trainings(this.props.match.params.user_id));
  };

  setIdFromParams() {
    this.vm.init(this.getId(), this.props.match.params.user_id);
  }

  renderModalBody() {
    return (
      <>
        <TrainingForm entity={this.vm.entity} possibleUsers={this.vm.possibleUsers} readonly={true} />
      </>
    );
  }
}
